// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6073":"6e40ec76","7033":"5aa0b010","8115":"fd847fd0"}[chunkId] + ".chunk.css";
};